<template>
  <m-card310 class="border rounded-lg" :image="content.thumbnail" :alt="content.title">

    <m-a :href="{name:'SinglePost',params:{slug:content.slug}}">
      <m-p class="text-dark">{{ content.title }}</m-p>
    </m-a>

  </m-card310>
</template>

<script>
import mCard310 from '../../Cards/Card310.vue'
import mIcon from "../../Icons/Icon.vue";
import mA from "../../Tags/A.vue";
import mP from "../../Tags/P.vue";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "PostCard205",
  methods: {contentSlicer},
  props: {
    content: {}
  },
  components: {mP, mA, mIcon, mCard310},

}
</script>

<style scoped>

</style>